import { isEmpty } from "@utils/var.check.ts";

const checkIfAtLeastOneNodeHasName = (nodes: any[], nestedFieldName = "nodes"): boolean => {
  for (const node of nodes) {
    if (!isEmpty(node.name)) {
      return true;
    }
    if (!isEmpty(node[nestedFieldName]) && checkIfAtLeastOneNodeHasName(node[nestedFieldName])) {
      return true;
    }
  }
  return false;
};

export { checkIfAtLeastOneNodeHasName };
